export default __webpack_public_path__ + "static/media/python.a695bbb6.png";